import { render, staticRenderFns } from "./bookmark.vue?vue&type=template&id=6213459e&scoped=true&lang=pug&"
import script from "./bookmark.vue?vue&type=script&lang=ts&"
export * from "./bookmark.vue?vue&type=script&lang=ts&"
import style0 from "./bookmark.vue?vue&type=style&index=0&id=6213459e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6213459e",
  null
  
)

export default component.exports